import { Choice } from "./Choice";
import { v4 as uuid } from "uuid";

/**A ChapterBeat represents a single block of content to be parsed and displayed by the GamePage. This may be a title, story text, an image name, or a list of choices.
 * A ChapterBeat's content type determines what media will be rendered in the block.
 * 
 * @param {Content} content - The content to be displayed in a block. Should be text, the exact name of an image file in assets/images, or a list where each 
 * item represents a choice. 
 * @param {ContentType} contentType - The type of content to be displayed in a block. The GamePage will check this to determine what to display.
 * */
export class ChapterBeat {
    content: Content
    contentType: ContentType
    beatId: string
    beatMedia?: string
    extraContent?: string
    constructor(content: Content, type: ContentType, beatMedia?: string, extraContent?: string) {
        this.content = content;
        this.contentType = type;
        this.beatId = uuid();
        this.beatMedia = beatMedia;
        this.extraContent = extraContent;
    }
}

type Content = string | string[] | Choice[] | Choice 

/**Indicates the media type of a ChapterBeat's content.*/
export enum ContentType {
    TEXT = "TEXT", CHOICE = "CHOICE", IMAGE = "IMAGE", TITLE = "TITLE", INFO = "INFO", CONSEQUENCE = "CONSEQUENCE", WARNING = "WARNING", SMALL_TITLE = "SMALL_TITLE"
}